const enum MeasurementEnum {
    PIECES = 'pieces',
    LITRES = 'litres',
    KILOGRAMS = 'kilograms',
    METRES = 'metres',
    SQUARE_METER = 'square-meter',
    CUBIC_METER = 'cubic-meter',
    LINEAR_METER = 'linear-meter',
}

export default MeasurementEnum;